﻿$.fn.dxCtrlWizardAnimLstItem = function custom_dxCtrlWizardAnimLstItem(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlwizardanimlstitem dx-ctrl");
        this.createInstance(new cdxCtrlWizardAnimLstItem(this, option));
    }
    return this;
}

window.cdxCtrlWizardAnimLstItem = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var isPhone = (parametre.isPhone || option.forcePhone)
    var dxList = null
    //var $DivRound = null
    var lstItemElement = []
    var hasIcone = false

    var heightItem = 0
    function mConstruit() {
        container.empty();
        container.css("position", "relative")

        dxList = $("<div style='position:absolute;left:0;width:100%,top:0;height:auto;opacity:1 !important;'/>").appendTo(container).dxList({
            dataSource: new DevExpress.data.DataSource({
                store: option.lstItem,
                paginate: false
            }),
            scrollingEnabled: false,
            showScrollbar: false,
            selectionMode: "none",
            disabled: true,
            itemTemplate: function (itemData, itemIndex, itemElement) {
                lstItemElement.push(itemElement)
                itemElement.parent().css("opacity", "1")
                if (isPhone) itemElement.css("padding-left", "0")
                var $Table = $("<table style='width:100%;table-layout:fixed;font-family:barlow condensed;'/>").appendTo(itemElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:140%;'/>").appendTo($Tr)
                if (isPhone) $Td.hide()
                if (itemData.title()) $Td.text(itemData.title())
                var $Td = $("<td style='width:60px;font-size:160%;text-align:center;'/>").appendTo($Tr)
                if (isPhone) $Td.css("font-size", "140%")
                if (isPhone) {
                    $Td.css({ "width": "25px", "display": "flex", "justify-content": "center", "align-items": "center" })
                }
                if (itemData.mGetClassIconeForLstItem()) {
                    $Td.css("font-size", "200%")
                    if (isPhone) {
                        $Td.css({ "font-size": "160%" })
                    }
                    $Td.html("<i class='" + itemData.mGetClassIconeForLstItem() + "'></i>")
                    hasIcone = true
                } else {
                    if (isPhone) {
                        var $Table = $("<table style='text-align:center;line-height:0.9'/>").appendTo($Td)
                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='border-bottom:" + theme.color + " 1px solid;'>" + (itemIndex + 1) + "</td>").appendTo($Tr)
                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td>" + option.lstItem.length + "</td>").appendTo($Tr)
                        //$Td.hml("99<br/>99")
                    } else {
                        $Td.text((itemIndex + 1) + "/" + option.lstItem.length)
                    }
                }
                heightItem = itemElement.innerHeight()
                console.log("heightitem:" + itemElement.innerHeight())
                window.setTimeout(function () { heightItem = itemElement.innerHeight() }, 0)
                //$Td.text("99/99")
            }
        }).dxList("instance")

        //$DivRound = $("<div style='position:absolute;right:12px;top:0;border-radius:50%;border:3px solid " + theme.backgroundcolorAccent + ";height:70px;width:70px;'/>").appendTo(container)
        //if (isPhone) {
        //    $DivRound.css("right", "-5px")
        //}

        window.setTimeout(function () { Me.mSetCurrent(option.lstItem[(option.indexSelectedPage ? option.indexSelectedPage : 0)]) }, 500)
    }

    this.mSetCurrent = function (ctrl) {
        dxList.element().stop()
        //$DivRound.stop()
        lstItemElement.forEach(function (itemElement, idx) { itemElement.stop() })
        var idxCurrent = option.lstItem.indexOf(ctrl)

        var center = container.innerHeight() / 2
        var top = center - idxCurrent * heightItem - heightItem / 2
        dxList.element().animate({ "top": top + "px" }, 800)
        var topRound = (center - heightItem / 2 + 5 + (isPhone ? 5 : 0))
        if (hasIcone && parametre.isPhone) topRound = (center - heightItem / 2)
        //$DivRound.animate({ "top": topRound + "px" }, 800)

        lstItemElement.forEach(function (itemElement, idx) {
            itemElement.stop()
            if (idx == idxCurrent) {
                itemElement.animate({
                    opacity: "1",
                    "font-weight": "700",
                    "border-radius": (parametre.isPhone ? "50%" : "10px")
                }, 800)
                itemElement.css({
                    "border-width": "3px",
                    "border-style": "solid",
                    "border-color": theme.backgroundcolorAccent
                })
                //itemElement.css({ "font-weight": "bold" })
            } else if (idx > idxCurrent) {
                var delta = (idx - idxCurrent) * 2
                opcity = 1 - delta / 10
                itemElement.animate({
                    opacity: opcity,
                    "font-weight": "400"
                }, 800)
                itemElement.css({
                    "border-width": "3px",
                    "border-style": "solid",
                    "border-color": "transparent"
                })
            } else {
                var delta = (idxCurrent - idx) * 2
                opcity = 1 - delta / 10
                itemElement.animate({
                    opacity: opcity,
                    "font-weight": "400"
                }, 800)
                itemElement.css({
                    "border-width": "3px",
                    "border-style": "solid",
                    "border-color": "transparent"
                })
            }
        })
    }

    this.element = function () { return container; }

    mConstruit();
}